import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children }) => {
  return (
    <div className="relative bg-black text-gray-100 selection:bg-teal-400/20 selection:text-teal-200">
      {/* Background with animation */}
      <div className="aura-background-component fixed top-0 left-0 w-full h-full saturate-150" style={{ zIndex: 0 }}>
        <div className="spline-container absolute top-0 left-0 w-full h-full">
          <iframe 
            src="https://my.spline.design/fireparticleloaderanimationdrstrangeporta-2XtNK3LbyCGmClvus9SdgnYJ/" 
            frameBorder="0" 
            width="100%" 
            height="100%" 
            title="Background Animation"
            style={{ border: 'none', display: 'block' }}
          />
        </div>
      </div>

      <div className="relative" style={{ zIndex: 1 }}>
        <Header />
        
        <main className="min-h-screen">
          {children}
        </main>
        
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
